<div class="toast toast-top toast-end">
@for(toast of toasts; track toast.id) {
  <div class="bg-base-100 rounded-lg shadow-md min-w-95 overflow-hidden">
    <div class="flex items-center h-16">
      <div class="w-2.5 h-full" [class]="getToastColor(toast.type)"></div>
      <div class="flex items-center justify-between w-full px-4">
        <span class="text-base font-semibold" data-testid="toast-message">{{ toast.message }}</span>
        <button class="btn btn-sm btn-ghost" (click)="remove(toast.id)">✕</button>
      </div>
    </div>
    <div class="flex">
      <div class="w-2.5 h-1" [class]="getToastColor(toast.type)"></div>
      <div
        class="h-1 toast__progress-bar"
        [class]="getToastColor(toast.type)"
        [style]="{'--duration': 3000 + 'ms', 'width': 'calc(100% - 0.625rem)'}"
        (animationend)="remove(toast.id)"
      >
      </div>
    </div>
  </div>
}
</div>
